import React, { Component } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';

import ZigZag from './ZigZag';
import DemandeDeDevis from './DemandeDeDevis';
import FormulaireDeDevis from './FormulaireDeDevis'
import Addresses from './Addresses';

import imageFacebook from '../images/facebook.png';
import imageTwitter from '../images/twitter.png';
import imageLinkedin from '../images/linkedin.png';

class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showForm: false
        };

        this.doShowForm = this.doShowForm.bind(this);
        this.doHideForm = this.doHideForm.bind(this);
    }

    doShowForm() {
        this.setState( { showForm: true } );
    }

    doHideForm() {
        this.setState( { showForm: false } );
    }

  render() {
    return (
    <div>
        <footer>
            <h6>Parlons-en !</h6>
            <p>Rencontrons-nous pour parler de vos projets numériques et de la transformation digitale de votre entreprise.</p>
            <DemandeDeDevis onClick={this.doShowForm} buttonId="Devis Footer" />

            <h6>Suivez notre actualité</h6>
            <a href="https://blog.arca-computing.fr/" className="btn btn-black">Aller sur le blog</a>

            <div className="bloc ligne social">
                <a href="https://www.facebook.com/arcacomputing/"><img src={imageFacebook} className="fb" alt="facebook" /></a>
                <a href="https://twitter.com/arcacomputing?lang=fr"><img src={imageTwitter} className="twitter" alt="twitter" /></a>
                <a href="https://www.linkedin.com/company/arca-computing/"><img src={imageLinkedin} className="link" alt="linkedin" /></a>
            </div>

            <Addresses />

            <ZigZag />
            <div className="copyright">
                <div>2010-2022 &#169; ARCA Computing - Tous droits réservés</div>
                <div><NavLink to="/mentions" onClick={this.toggleMenu}>Mentions légales</NavLink></div>
            </div>
            <div className="bottom gradient-arca"></div>
        </footer>
        <FormulaireDeDevis show={this.state.showForm} onCancel={this.doHideForm} />
    </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js